import { defineComponent as _defineComponent } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { computed } from 'vue'
import { orderBy } from 'lodash'
import { useJobFilterStore } from '../field-view-next/JobsFilterStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceTypeSelector',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({ (event: 'input', value: number): void }), expose: any, slots: any, attrs: any }) {




const newFilterStore = useJobFilterStore()

const { getAllResourceTypes: allResourceTypes } = createNamespacedHelpers(
  'resourceTypes'
).useGetters(['getAllResourceTypes'])

const selectedResourceTypeIds = computed(() => {
  const filtered = allResourceTypes.value.filter((type) =>
    newFilterStore.selectedResourceTypes.includes(type.id)
  )

  return orderBy(filtered, [(type) => type.name.toLowerCase()])
})

const hasAvailableResourceTypes = computed(
  () => selectedResourceTypeIds.value.length > 0
)

function handleChange(value: number) {
  emit('input', value)
}

return { __sfc: true,emit, newFilterStore, allResourceTypes, selectedResourceTypeIds, hasAvailableResourceTypes, handleChange }
}

})